import { render, staticRenderFns } from "./ClientTokens.vue?vue&type=template&id=f21b0cea"
import script from "./ClientTokens.vue?vue&type=script&lang=js"
export * from "./ClientTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports